
export const LOAD_MODE_STARTED = 'LOAD_MODE_STARTED'
export const LOAD_MODE_SUCCESS = 'LOAD_MODE_SUCCESS'
export const LOAD_MODE_FAIL = 'LOAD_MODE_FAIL'
export const ADD_MODE = 'ADD_MODE'
export const UPDATE_MODE = 'UPDATE_MODE'
export const DELETE_MODE = 'DELETE_MODE'
